import { _ } from "../../core/polyglot/polyglot.js";
import { makeMonitorRepository } from "../../core/repositories/repositoryBuilders.js";
import externalDocument from "../shared/externalDocument.js";
import session from "../../core/session.js";
import SignUpRequestFormWidget from "./SignUpRequestFormWidget/SignUpRequestFormWidget.js";
import SignUpRequestInfo from "../../models/SignUpRequestInfo.js";

/**
 * `signUpRequestDocument' is a document displaying an input form widget used by
 * potential new customers to sign up for a trial/demo version.
 */

/**
 * Todo: Add JSDoc comment
 */
function signUpRequestDocument(spec, my) {
	spec ||= {};
	my ||= {};

	const that = externalDocument(spec, my);

	that.showHeader = true;
	that.showFooter = true;

	that.documentId = "no-leftmenu admin-body my-companies-body";
	that.pageTitle = _("finsit sign up request form");
	that.title = _("finsit sign up request form");

	my.defaultCountryId = "UK";
	my.defaultIntegrationType = "Xero";
	my.userHasSignedUp = false;

	my.repository = makeMonitorRepository({
		route: "/External/Signup/RequestDemo",
		antiForgeryToken: session.getAntiForgeryToken(),
	});

	my.signUpRequestFormWidget = new SignUpRequestFormWidget({
		submitCallback: async (signUpRequestInfo) => {
			try {
				await my.repository.save({
					model: signUpRequestInfo,
					successMessage: "",
				});

				my.userHasSignedUp = true;
				that.update();
			} catch (error) {
				const errorType = error.responseJSON.typeOfError;
				if (errorType === "Validation") {
					throw error;
				}
				my.redirectToUrl(`error?id=${my.getErrorMessageId(errorType)}`);
			}
		},
	});

	my.getErrorMessageId = function (typeOfError) {
		return typeOfError === "RequestNotFound"
			? "SignUpRequestNotFound"
			: "SignUpRequestUnknownError";
	};

	that.show = function ({
		requestId,
		firstName,
		lastName,
		phone,
		email,
		integrationType,
		companyName,
		postcode,
		companySize,
		businessOperationType,
	}) {
		my.signUpRequestFormWidget.setSignUpRequestInfo({
			signUpRequestInfo: new SignUpRequestInfo({
				requestId: decodeURIComponent(requestId || ""),
				firstName: decodeURIComponent(firstName || ""),
				lastName: decodeURIComponent(lastName || ""),
				phone: decodeURIComponent(phone || ""),
				email: decodeURIComponent(email || ""),
				countryId: my.defaultCountryId,
				integrationType: decodeURIComponent(integrationType || ""),
				companyName: decodeURIComponent(companyName || ""),
				postcode: decodeURIComponent(postcode || ""),
				companySize: decodeURIComponent(companySize || ""),
				businessOperationType: decodeURIComponent(
					businessOperationType || "",
				),
			}),
		});
	};

	my.renderConfirmationMessageOn = function (html) {
		html.div(
			{ id: "document-title" },
			html.h1(_("Sign up request confirmation")),
		);

		html.div(
			{ klass: "row" },
			html.div(
				{
					class: "col-lg-4 col-lg-offset-4 col-sm-6 col-sm-offset-3 text-center",
				},
				html.p(
					{ klass: "lead", "data-test": "confirmation-message" },
					_(
						"Thank you for your request. A member of our team will contact you shortly.",
					),
				),
			),
		);
	};

	my.renderDocumentContentOn = function (html) {
		if (my.userHasSignedUp) {
			my.renderConfirmationMessageOn(html);
			return;
		}

		if (!my.signUpRequestFormWidget) {
			return;
		}

		html.div(
			{ class: "row" },
			html.div(
				{ class: "col-lg-6 col-lg-offset-3 col-sm-8 col-sm-offset-2" },
				my.signUpRequestFormWidget,
			),
		);
	};

	return that;
}

export default signUpRequestDocument;
